import React, { Component } from 'react'
import styled from 'styled-components'

import RatingContent from 'components/RatingContent'
import RatingHeader from 'components/RatingHeader'
import RatingFooter from 'components/RatingFooter'

/**
 * Página autónoma da avaliação da adesão (rating).
 *
 * Réplica em React do template rating.php do WordPress. É uma página completa,
 * com header e footer próprios, para o utilizador ser direcionado diretamente
 * aqui (a partir do link do email) sem necessidade de iframe.
 *
 * O link do email aponta para `.../apps/simulador-rating/?subscription=X&token=Y`
 * e os parâmetros são lidos de window.location.search. Têm de vir na query
 * string real (antes de qualquer '#'), porque a app usa hash history.
 *
 * Montada através do id `adene-simulador-rating` (ver index.js / index.html).
 */
export default class RatingStandalone extends Component {
  constructor(props) {
    super(props)

    const params = new URLSearchParams(window.location.search)
    const subscription = params.get('subscription')
    const token = params.get('token')

    this.state = {
      subscription,
      token,
      // Sem token/subscription não dá para submeter: mostramos erro inline.
      invalid: !subscription || !token,
      submitted: false,
    }
  }

  handleSuccess = () => {
    // Mantemos o aviso ao eventual pai (inócuo quando não há iframe) e mostramos
    // a confirmação de agradecimento.
    window.parent.postMessage({ type: 'submitted' }, '*')
    this.setState({ submitted: true })
  }

  handleClose = () => {
    // Sem iframe (window.parent === window), reencaminha para o site;
    // dentro de um iframe, avisa o pai para fechar.
    if (window.parent === window) {
      window.location.href = 'https://poupaenergia.pt/'
    } else {
      window.parent.postMessage({ type: 'close' }, '*')
    }
  }

  render() {
    const { subscription, token, invalid, submitted } = this.state

    return (
      <Page>
        <RatingHeader />
        <Main>
          <Box>
            {invalid ? (
              <Message>
                <MessageTitle>Link inválido ou expirado</MessageTitle>
                <MessageText>
                  Não foi possível abrir a avaliação. Por favor, utilize o link
                  enviado no seu email.
                </MessageText>
              </Message>
            ) : submitted ? (
              <Message>
                <MessageTitle>Obrigado!</MessageTitle>
                <MessageText>
                  O seu contributo é importante para melhorar o Poupa Energia
                </MessageText>
                <CloseButton type='button' onClick={this.handleClose}>
                  Fechar
                </CloseButton>
              </Message>
            ) : (
              <RatingContent
                subscription={subscription}
                token={token}
                onSuccess={this.handleSuccess}
              />
            )}
          </Box>
        </Main>
        <RatingFooter />
      </Page>
    )
  }
}

const Page = styled.div`
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
`

const Main = styled.main`
  flex: 1 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px 16px;
  background: #f2f4f3;
`

const Box = styled.div`
  width: 100%;
  max-width: 640px;
  background: #fff;
  border: 1px solid #ececec;
`

const Message = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 40px 24px;
  text-align: center;
`

const MessageTitle = styled.h3`
  color: #1d1e22;
  font-family: Nunito;
  font-size: 20px;
  font-weight: 700;
  line-height: 28px;
  margin: 0;
`

const MessageText = styled.p`
  color: #3e3e3e;
  font-family: Nunito;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  margin: 0;
`

const CloseButton = styled.button`
  margin-top: 8px;
  padding: 8px 24px;
  border: none;
  cursor: pointer;
  color: #fff;
  font-family: Nunito;
  font-size: 14px;
  font-weight: 500;
  background: linear-gradient(270deg, #006736 -58.87%, #93c13e 100%);
`



// WEBPACK FOOTER //
// ./src/containers/RatingStandalone/index.js